import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

import InputField from '../../../../components/inputs/inputField';
import ToggleField from '../../../../components/inputs/toggleField';
import SelectField from '../../../../components/inputs/selectField';

class AddPointsModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			availablePointOptions: this.props.availablePoints.map((p) => {
				return { label: p.customLabel ? p.customLabel : p.actionName, value: p._id };
			}).sort((a, b) => a.label.localeCompare(b.label)),
			selectedValue: { label: '', color: '#00B8D9' },
			category: null,
			defaultCategoryOptions: [...(this.props.categoryOptions || [])],
			filteredCategoryOptions: [...(this.props.categoryOptions || [])],
			newCategoryChosen: false,
			isCustomPoint: false,
			customLabel: '',
			actionName: '',
			description: '',
			pointSuffix: '',
			pointValue: 0,
			maxPointsAllowed: 0,
			oncePerReference: false,
			referenceModel: 'attendee',
			applyToAll: true,
			active: false,
			callToActionLabel: '',
			callToActionUrl: '',
			doNotShow: false,
			submitting: false,
			invalid: false,
			success: false,
			callToActionType: 'external',
			callToActionInternalType: 'page',
			callToActionInternalTypeOptions: [
				{ label: 'Page', value: 'page' },
				{ label: 'Session', value: 'session' }
			],
			callToActionExternalTypeOptions: [
				{ label: 'External', value: 'external' },
				{ label: 'Internal', value: 'internal' }
			],
			pages: this.props.event.appConfiguration.screens.map((s) => {
				return { label: s.name, value: s.id };
			}),
			selectedPage: '',
			selectedSession: '',
			modelOptions: [],
			applicableObjects: []
		};
	}
	handlePointsChosen = async (e) => {
		const { orgId, eventId } = this.props;
		const pointsChosen = this.props.availablePoints.find((p) => p._id == e.value);
		if (pointsChosen) {
			let modelOptions = [];
			if (pointsChosen.referenceModel) {
				switch (pointsChosen.referenceModel) {
					case 'Attendee':
						modelOptions = this.props.attendees.map((a) => {
							return { label: a.firstName + ' ' + a.lastName, value: a._id };
						});
						break;
					case 'Session':
						modelOptions = this.props.sessions.map((s) => {
							return { label: s.name, value: s._id };
						});
						break;
					case 'Survey': 
						modelOptions = this.props.sessions.filter(s => s.surveyId).map((s) => {
							const surveyId = s.surveyId;
							return {
								label: s.name,
								value: surveyId
							};
						});
						break;
					case 'Feed':
						modelOptions = this.props.feeds?.map((f) => {
							return { label: f.feedName, value: f._id };
						});
						break;
					case 'Form':
						//fetch forms
						const forms = await API().get(`Organizations/${orgId}/events/${eventId}/forms`);
						modelOptions = forms.data.forms.map((f) => {
							return { label: f.name, value: f._id };
						});
						break;
					default:
						break;
				}
			}
			this.setState({
				selectedValue: e,
				actionName: pointsChosen.actionName,
				description: pointsChosen.description,
				pointSuffix: pointsChosen.pointSuffix,
				value: pointsChosen.value,
				maxPointsAllowed: pointsChosen.maxPointsAllowed,
				oncePerReference: pointsChosen.oncePerReference,
				referenceModel: pointsChosen.referenceModel,
				callToActionLabel: pointsChosen.callToActionLabel,
				callToActionUrl: pointsChosen.callToActionUrl,
				active: false,
				doNotShow: false,
				modelOptions: modelOptions
			});
		}
	};

	handleCategoryInputChange = (input) => {
		const newCategory = {
			label: 'New category: ' + input,
			color: '#00B8D9',
			new: true
		};
		const filteredCategories = this.state.defaultCategoryOptions.filter(
			(category) => category.label.toLowerCase().includes(input.toLowerCase())
		);
		this.setState({
			filteredCategoryOptions: [...filteredCategories, newCategory]
		});
	};

	handleCategoryChosen = (selected) => {
		if (selected.new) {
			this.setState({ 
				category: { ...selected, label: selected.label.split('New category: ')[1] },
				newCategoryChosen: true 
			});
		} else {
			this.setState({ 
				category: selected,
				newCategoryChosen: false 
			});
		}
	};

	handleSetCustomPoint = (e) => {
		const { isCustomPoint } = this.state;
		if (isCustomPoint) {
			this.setState({ isCustomPoint: false })
		} else {
			this.setState({
				isCustomPoint: true,
				selectedValue: { label: 'Custom Point', value: 'custom' },
				actionName: '',
				description: '',
				pointSuffix: '',
				pointValue: 0,
				maxPointsAllowed: 0,
				oncePerReference: false,
				callToActionLabel: '',
				callToActionUrl: '',
				active: false,
				doNotShow: false
			})
		}
	}

	submitInteractionPoints = () => {
		const { orgId, eventId } = this.props;
		const { callToActionType, callToActionInternalType, selectedPage, selectedSession } = this.state;
		if (this.state.selectedValue.value) {

			let callToActionUrl = this.state.callToActionUrl;

			if (callToActionType === 'internal') {
				if (callToActionInternalType === 'page') {
					callToActionUrl = selectedPage.value;
				} else {
					callToActionUrl = selectedSession.value
				}
			}

			const data = {
				customLabel: this.state.customLabel ? this.state.customLabel : this.state.actionName,
				pointId: this.state.selectedValue.value,
				category: this.state.category?.new ? this.state.category.label : this.state.category?.value,
				description: this.state.description,
				pointSuffix: this.state.pointSuffix,
				pointValue: this.state.pointValue,
				maxPointsAllowed: this.state.maxPointsAllowed,
				oncePerReference: this.state.oncePerReference,
				callToActionLabel: this.state.callToActionLabel,
				callToActionUrl: callToActionUrl,
				active: this.state.active,
				doNotShow: this.state.doNotShow,
				callToActionType: this.state.callToActionType,
				callToActionInternalType: this.state.callToActionInternalType,
				referenceModel: this.state.referenceModel,
				applicableObjects: this.state.applicableObjects.map((a) => a.value)
			};
			this.setState({ submitting: true });
			API().post(`Organizations/${orgId}/events/${eventId}/interactions/point`, data).then((res) => {
				if (res.data) {
					this.props.addInteractionPoint({ ...res.data.interactionPoint, active: this.state.active });
					this.props.toggle();
				}
			}).catch((err) => {
				console.log(err);
				this.setState({ submitting: false });
			})
		} else {
			this.setState({ invalid: true });
		}
	};

	render() {
		const { isOpen, toggle, sessions } = this.props;
		const {
			availablePointOptions,
			submitting,
			invalid,
			customLabel,
			selectedValue,
			description,
			pointSuffix,
			pointValue,
			maxPointsAllowed,
			oncePerReference,
			callToActionLabel,
			callToActionUrl,
			active,
			doNotShow,
			isCustomPoint,
			modelOptions
		} = this.state;

		return (
			<div>
				<FieldModal
					size="small"
					isOpen={isOpen}
					modalTitle={"Add Interaction Point"}
					bodyHeaderText={'Points will be earned by attendees as they complete actions'}
					bodyDescription={''}
					bodyContent={() => {
						return (
							<div>
								<ToggleField label="Set Custom Point" checked={isCustomPoint} icons={false} onChange={this.handleSetCustomPoint} />
								{!isCustomPoint && <SelectField
									label="Available Point Options"
									value={selectedValue}
									name="availablePointOptions"
									options={availablePointOptions}
									required={true}
									errorTrigger={invalid}
									onChange={this.handlePointsChosen}
								/>
								}
								{(selectedValue.value || isCustomPoint) && (
									<div>

										<InputField
											label="Label"
											value={customLabel}
											onChange={(e) => this.setState({ customLabel: e.target.value })}
										/>
										<InputField
											label="Description"
											value={description}
											onChange={(e) => this.setState({ description: e.target.value })}
										/>

										<SelectField
											label="Category"
											value={this.state.category}
											options={this.state.filteredCategoryOptions}
											onChange={this.handleCategoryChosen}
											onInputChange={this.handleCategoryInputChange}
										/>

										<InputField
											label="Points Suffix"
											value={pointSuffix}
											onChange={(e) => this.setState({ pointSuffix: e.target.value })}
										/>

										<InputField
											label="Point Value"
											value={pointValue}
											onChange={(e) => this.setState({ pointValue: e.target.value })}
										/>

										<InputField
											label="Submission Limit"
											type="number"
											min="0"
											value={maxPointsAllowed}
											onChange={(e) => this.setState({ maxPointsAllowed: e.target.value })}
										/>

										<ToggleField
											label="Once Per Reference"
											checked={oncePerReference}
											icons={false}
											onChange={() =>
												this.setState({
													oncePerReference: !oncePerReference
												})}
										/>

										{this.state.referenceModel && this.state.referenceModel !== '' && <ToggleField
											label="Apply to all"
											checked={this.state.applyToAll}
											icons={false}
											onChange={() =>
												this.setState({
													applyToAll: !this.state.applyToAll
												})}
										/>}
										{!this.state.applyToAll && this.state.referenceModel && (<SelectField
											isMulti={true}
											label={`Select ${this.state.referenceModel}s`}
											value={this.state.applicableObjects}
											options={modelOptions}
											onChange={(e) =>
												this.setState({
													applicableObjects: e
												})
											}
										/>)}


										<InputField label="Call To Action Label" value={callToActionLabel}
											onChange={(e) =>
												this.setState({
													callToActionLabel: e.target.value
												})}

										/>

										<SelectField
											label="Call To Action Type"
											value={this.state.callToActionExternalTypeOptions.find((o) => o.value === this.state.callToActionType)}
											options={this.state.callToActionExternalTypeOptions}
											onChange={(e) =>
												this.setState({
													callToActionType: e.value,
													callToActionUrl: ''
												})}
										/>

										{this.state.callToActionType === 'internal' && (
											<SelectField
												label="Call To Action Internal Type"
												value={this.state.callToActionInternalTypeOptions.find((o) => o.value === this.state.callToActionInternalType)}
												options={this.state.callToActionInternalTypeOptions}
												onChange={(e) =>
													this.setState({
														callToActionInternalType: e.value,
														callToActionUrl: ''

													})}
											/>
										)}

										{this.state.callToActionType === 'internal' && this.state.callToActionInternalType === 'session' && (
											<SelectField
												label="Session"
												value={this.state.selectedSession}
												options={sessions.map((s) => {
													return { label: s.name, value: s._id };
												})}
												onChange={(e) =>
													this.setState({
														selectedSession: e,
														callToActionUrl: e.label
													})}
											/>
										)
										}

										{this.state.callToActionType === 'internal' && this.state.callToActionInternalType === 'page' && (
											<SelectField
												label="Page"
												value={this.state.selectedPage}
												options={this.state.pages}
												onChange={(e) =>
													this.setState({
														selectedPage: e,
														callToActionUrl: e.label
													})}
											/>
										)
										}


										<InputField label="Call To Action Target"
											value={callToActionUrl}
											onChange={(e) =>
												this.setState({
													callToActionUrl: e.target.value
												})}
											disabled={this.state.callToActionType === 'internal'}
										/>

										<ToggleField
											label="Active"
											checked={active}
											icons={false}
											onChange={() =>
												this.setState({
													active: !active
												})}
										/>
										<ToggleField
											label="Do Not Show"
											checked={doNotShow}
											icons={false}
											onChange={() =>
												this.setState({
													doNotShow: !doNotShow
												})}
										/>
									</div>
								)}
							</div>)
					}}
					toggle={toggle}
					actionButtonLabel={!submitting ? 'Submit' : 'Adding...'}
					actionButton={() => this.submitInteractionPoints()}
					actionButtonDisabled={submitting}
				></FieldModal>
			</div>

		);
	}
}

export default AddPointsModal;
